import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initializeApp } from "firebase/app";

import './i18n';

const firebaseConfig = {
  apiKey: "AIzaSyCPs9Ms0HE-glcC1bVMr7XKxk65o3pj84Q",
  authDomain: "alamalmuslim-portal.firebaseapp.com",
  projectId: "alamalmuslim-portal",
  storageBucket: "alamalmuslim-portal.appspot.com",
  messagingSenderId: "580385023402",
  appId: "1:580385023402:web:e4e5b23e2543110faab7d3"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
